import { ShapeProps } from './types';

const SemiCircle = ({ fill, size }: ShapeProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 204 187"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M193.484 137.969C200.035 143.42 203.31 146.146 203.317 150.247C203.324 154.349 200.409 156.794 194.58 161.684C177.094 176.353 154.776 184.997 130.674 186.144C100.393 187.585 69.7745 177.073 45.5556 156.921C21.3367 136.769 5.50085 108.627 1.5317 78.6861C-1.62747 54.8554 2.93703 31.4388 14.3131 11.6852C18.1052 5.10043 20.0013 1.80805 24.0539 1.08416C28.1066 0.360267 31.3821 3.08584 37.9333 8.53699L193.484 137.969Z"
				fill={fill}
			/>
		</svg>
	);
};

export default SemiCircle;
